import React from 'react';

import { useUserIdentity } from '../../../stores-v2/StoreContext';
import { useFlagsCombination } from '../../../utility/useFlagsCombination';
import { TimelineFrameThumbnails as NewTimelineFrameThumbnails } from './_TimelineFrameThumbnails';
import { TimelineFrameThumbnails as PrevTimelineFrameThumbnails } from './TimelineFrameThumbnails';

interface TimelineFrameThumbnailsProps {
  storyId: string;
  videoId: string;
  elementId?: string;
  trimStart: number;
  duration: number;
  elementWidth: number;
  height: number;
  videoWidth?: number;
  videoHeight?: number;
  fallbackThumbnailUrl?: string;
  hasThumbnails?: boolean;
}

export const TimelineFrameThumbnails: React.FC<
  TimelineFrameThumbnailsProps
> = props => {
  const { currentRole } = useUserIdentity();
  const { enableExperimentalTimelineFrameThumbnails } =
    useFlagsCombination(currentRole);

  if (enableExperimentalTimelineFrameThumbnails) {
    // Ensure elementId is provided for the experimental version
    const experimentalProps = {
      ...props,
      elementId: props.elementId || props.videoId, // Fallback to videoId if elementId not provided
    };
    return <NewTimelineFrameThumbnails {...experimentalProps} />;
  }

  // Remove experimental-only props that the old implementation doesn't expect
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const { elementId, hasThumbnails, ...oldProps } = props;
  return <PrevTimelineFrameThumbnails {...oldProps} />;
};

TimelineFrameThumbnails.displayName = 'TimelineFrameThumbnails';

export default TimelineFrameThumbnails;
